import { render, staticRenderFns } from "./prescripteur_edit.vue?vue&type=template&id=42e8c8db&"
import script from "./prescripteur_edit.vue?vue&type=script&lang=js&"
export * from "./prescripteur_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports